
import usefulLinkActions from '../../../actions/usefulLinkActions';
import usefulLinkInputFields from './usefulLinkInputFields';
import generateEntityEditor from '../../../hocs/generateEntityEditor';

const UsefulLinkEditor = generateEntityEditor({
  entitySingularString: 'usefulLink',
  entityPluralString: 'usefulLinks',
  entityActions: usefulLinkActions,
  returnRoutePath: '/useful-links-listing',
  fields: usefulLinkInputFields,
});

export default UsefulLinkEditor;
